<template>
  <div class="container">
    <el-container style="height: 100vh">
      <!-- 左侧App列表 -->
      <el-aside width="200px" style="border-right: 1px solid #e6e6e6">
        <div style="padding: 15px 10px; border-bottom: 1px solid #e6e6e6; font-weight: bold">
          定制前端
        </div>
        <el-tree
          :data="appTreeData"
          :props="treeProps"
          :highlight-current="true"
          node-key="id"
          @node-click="handleAppSelect"
          style="padding: 10px 0"
        >
          <span class="custom-tree-node" slot-scope="{ node }">
            <span>{{ node.label }}</span>
          </span>
        </el-tree>
      </el-aside>
      
      <!-- 右侧标签页 -->
      <el-main style="padding: 0">
        <el-tabs v-model="activeTabName" @tab-click="handleTabClick" style="height: 100%">
          <el-tab-pane label="APP版本管理" name="version" style="height: 100%">
            <AppVersionManage v-if="currentApp.id && activeTabName === 'version'" :app-info="currentApp" />
          </el-tab-pane>
          
          <el-tab-pane label="APP升级管理" name="upgrade" style="height: 100%">
            <AppUpgradeManage v-if="currentApp.id && activeTabName === 'upgrade'" :app-info="currentApp" />
          </el-tab-pane>
          
          <el-tab-pane label="APP启动页" name="startup" style="height: 100%">
            <AppStartupManage v-if="currentApp.id && activeTabName === 'startup'" :app-info="currentApp" />
          </el-tab-pane>
          
          <el-tab-pane label="APP引导页" name="guide" style="height: 100%">
            <AppGuideManage v-if="currentApp.id && activeTabName === 'guide'" :app-info="currentApp" />
          </el-tab-pane>
          
          <el-tab-pane label="产品中心栏目配置" name="productColumn" style="height: 100%">
            <ProductColumnManage v-if="currentApp.id && activeTabName === 'productColumn'" :app-info="currentApp" />
          </el-tab-pane>
          
          <el-tab-pane label="产品中心产品配置" name="productList" style="height: 100%">
            <ProductListManage v-if="currentApp.id && activeTabName === 'productList'" :app-info="currentApp" />
          </el-tab-pane>
          
          <el-tab-pane label="banner图" name="banner" style="height: 100%">
            <BannerManage v-if="currentApp.id && activeTabName === 'banner'" :app-info="currentApp" />
          </el-tab-pane>
          
          <el-tab-pane label="短信签名" name="sms" style="height: 100%">
            <SmsManage v-if="currentApp.id && activeTabName === 'sms'" :app-info="currentApp" />
          </el-tab-pane>
        </el-tabs>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { getAppList } from '@/api/custom-frontend'
import AppVersionManage from './components/AppVersionManage.vue'
import AppUpgradeManage from './components/AppUpgradeManage.vue'
import AppStartupManage from './components/AppStartupManage.vue'
import AppGuideManage from './components/AppGuideManage.vue'
import ProductColumnManage from './components/ProductColumnManage.vue'
import ProductListManage from './components/ProductListManage.vue'
import BannerManage from './components/BannerManage.vue'
import SmsManage from './components/SmsManage.vue'

export default {
  name: 'CustomFrontendAppSetting',
  components: {
    AppVersionManage,
    AppUpgradeManage,
    AppStartupManage,
    AppGuideManage,
    ProductColumnManage,
    ProductListManage,
    BannerManage,
    SmsManage
  },
  data() {
    return {
      appTreeData: [],
      treeProps: {
        children: 'children',
        label: 'name'
      },
      currentApp: {},
      activeTabName: 'version'
    }
  },
  mounted() {
    this.loadAppList()
  },
  methods: {
    async loadAppList() {
      try {
        const res = await getAppList({ disabled: false })
        if (res && res.err_code === 0) {
          this.appTreeData = res.rows || []
          
          // 默认选中第一个App
          if (this.appTreeData.length > 0) {
            this.currentApp = this.appTreeData[0]
            this.$nextTick(() => {
              this.$refs.tree && this.$refs.tree.setCurrentKey(this.currentApp.id)
            })
          }
        }
      } catch (error) {
        console.error('获取App列表失败:', error)
      }
    },
    
    handleAppSelect(data) {
      this.currentApp = data
    },
    
    handleTabClick(tab) {
      this.activeTabName = tab.name
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 100vh;
  
  .el-aside {
    background-color: #f5f7fa;
    
    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
    }
  }
  
  /deep/ .el-tree-node__content {
    height: 35px;
    
    &:hover {
      background-color: #e6f7ff;
    }
  }
  
  /deep/ .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: #e6f7ff;
    color: #1890ff;
  }
  
  /deep/ .el-tabs__header {
    margin: 0;
    border-bottom: 1px solid #e4e7ed;
  }
  
  /deep/ .el-tabs__content {
    padding: 0;
    height: calc(100% - 55px);
  }
  
  /deep/ .el-tab-pane {
    height: 100%;
  }
}
</style>